import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Spinner } from './ui/spinner';
import { useAuth } from '../context/AuthContext';
import { useBrand } from '../context/BrandContext';

// `feature` is the route-level counterpart of Sidebar's feature gate: some pages share a
// module with another page but need warehouse tables the brand may not have, so a brand lists
// the feature under `unsupported` in its config to hide just that one. Without this check the
// nav item disappeared but the URL still rendered the page — see
// livechat_mining.crm_intelligence.
const ProtectedRoute = ({ children, permission, module: requiredModule, feature }) => {
  const { user, loading, hasPermission, permissions } = useAuth();
  const { activeBrandInfo, brands } = useBrand();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner size="lg" />
      </div>
    );
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }
  if (brands.length === 0) return <Navigate to="/no-brand" replace />;
  if (permissions.length === 0) return <Navigate to="/no-role" replace />;

  const brandModules = activeBrandInfo?.modules;
  const moduleBlocked = requiredModule && brandModules && !brandModules.includes(requiredModule);
  const featureBlocked = feature && (activeBrandInfo?.unsupported || []).includes(feature);

  if (moduleBlocked || featureBlocked || (permission && !hasPermission(permission))) {
    const hasModule = (mod) => !brandModules || brandModules.includes(mod);
    if (permissions.includes('view:vip_dashboard') && hasModule('vip')) return <Navigate to="/vip-dashboard" replace />;
    if (permissions.includes('view:vip_private') && hasModule('vip_private')) return <Navigate to="/vip-private" replace />;
    if (permissions.includes('view:conversion') && hasModule('conversion')) return <Navigate to="/conversion" replace />;
    if (permissions.includes('view:bot_evaluation') && hasModule('chatbot')) return <Navigate to="/bot-evaluation" replace />;
    return <Navigate to="/notifications" replace />;
  }

  return children;
};

export default ProtectedRoute;
